export type CreateFn<P extends object, T extends object> = (el: P) => T;
export type WithId<T extends object> = T & { id: string | number };

export const assertListWithIdElements = <T extends object>(
  el: T[]
): el is WithId<T>[] => assertWithId(el[0]);

export const assertWithId = <T extends object>(el?: T): el is WithId<T> =>
  Boolean(el) &&
  'id' in el &&
  (typeof el.id === 'string' || typeof el.id === 'number');
